<template>
  <div id="app" :style="{'zoom':zoomData}">
    <headers></headers>
    <backToTheTop></backToTheTop>
    <router-view/>
  </div>
</template>

<script>
import footers from '@/components/footers.vue'
  import headers from '@/components/headers.vue'
  import backToTheTop from '@/components/backToTheTop.vue'
export default {
  name: 'App',
  components:{footers,headers,backToTheTop},
  data(){
    return{
      screenWidth:1500,
      zoomData:1
    }
  },
  mounted() {
    this.isMobile();


    this.screenWidth = document.body.clientWidth
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth
      })()
    }
  },
  watch: {
    screenWidth: {
      handler: function (val) {
        if (val < 1500) {
          this.zoomData = (val / 1500).toFixed(2)
        }
      },
      immediate: true,
      deep:true
    },
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },

    isMobile() {

      if(JSON.parse(window.localStorage.getItem("routes"))){
        return;
      }
      if (this._isMobile()) {
        console.log('222222222');
        window.location.href = 'http://wap.changyin.sh.cn/'
        window.localStorage.setItem("routes",JSON.stringify("wap"))
      } else {
        console.log(1111111);
        window.location.href = 'http://www.changyin.sh.cn/'
        window.localStorage.setItem("routes",JSON.stringify("pc"))
      }
    },
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue